<template>
  <div>
    <section class="section is-title-bar">
      <div class="level">
        <div class="level-left">
          <div class="level-item">
            <h1 class="title is-5">{{ getSmsTitle }}</h1>
          </div>
        </div>
      </div>
    </section>
    <section class="container section page-header section is-main-section">
      <b-tabs v-model="activeTab">
        <b-tab-item class="label" label="Filter">
          <form @submit.prevent="showListing">
            <div>
              <card-component>
                <div class="columns form-row">
                  <div class="column">
                    <div class="field">
                      <label class="label">
                        Franchisee
                        <span class="requir">*</span>
                      </label>
                      <div class="control select is-fullwidth">
                        <select required v-model="sms.franchiseeID">
                          <option value>---Select---</option>
                          <option :value="franchisee.id" v-for="franchisee in franchiseeArr" :key="franchisee.id">{{ franchisee.companyName }}</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div class="column">
                    <div class="field">
                      <label class="label">
                        UserType
                        <span class="requir">*</span>
                      </label>
                      <div class="control select is-fullwidth">
                        <select v-model.trim="sms.userTypeValue" name="userType" @change="onChangeUserType($event)">
                          <option :value="users.name" v-for="users in UserType" :key="users.name"> {{ users.name }}</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div class="column parent-class" v-show="Parent">
                    <div class="field">
                      <label class="label">
                        Academic Year
                        <span class="requir">*</span>
                      </label>
                      <div class="control select is-fullwidth">
                        <select v-model="sms.academicYearsValue" :required="requiredP">
                          <option value="">---Select---</option>
                          <option :value="year.id" v-for="year in academicYears" :key="year.id"> {{ year.academicYear }}</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div class="column parent-class">
                    <div class="field">
                      <label class="label">
                        SMS Template Type
                        <span class="requir">*</span>
                      </label>
                      <div class="control select is-fullwidth">
                        <select v-model="sms.templateTypeValue" @change="onChangeSMSTemplate($event)" :required="required" :disabled="id">
                          <option value>---Select---</option>
                          <option :value="type.id" v-for="type in TemplateType" :key="type.templateName"> {{ type.templateName }}</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="columns form-row">
                  <div class="column is-9" v-show="Parent">
                    <div class="field">
                      <div class="control is-fullwidth">
                        <label class="label"><br /> </label>
                        <input type="checkbox" @change="checkBoxPoint($event)" id="point_of_contact" value="point_of_contact" v-model="sms.pointOfContact" />
                        <label class="chk">Point Of Contact</label>
                        <input type="checkbox" @change="checkBoxPoint($event)" id="Father" value="Father" :disabled="notPointChk" v-model="sms.pointOfContact" />
                        <label class="chk">Parent</label>
                        <input type="checkbox" @change="checkBoxPoint($event)" id="Mother" value="Mother" :disabled="notPointChk" v-model="sms.pointOfContact" />
                        <label class="chk">Mother</label>
                        <input type="checkbox" @change="checkBoxPoint($event)" id="Guardian" value="Guardian" :disabled="notPointChk" v-model="sms.pointOfContact" />
                        <label class="chk">Guardian</label>
                      </div>
                    </div>
                  </div>
                  <div class="column is-4" v-show="Staff">
                    <div class="field">
                      <label class="label"> Staff Department (Selected : {{ sms.staffDept.length }}) </label>
                      <div class="control select is-fullwidth">
                        <multiselect
                        class="overflowmultiselect1"
                          label="name"
                          track-by="name"
                          :close-on-select="false"
                          :preserve-search="false"
                          :preselect-first="false"
                          :multiple="true"
                          :options="staffDeptArr"
                          v-model="sms.staffDept"
                        >
                          <template slot="selection" slot-scope="{ values, isOpen }"
                            ><span class="multiselect__single" v-if="values.name &amp;&amp; !isOpen">{{ values.name }} </span></template
                          >
                        </multiselect>
                      </div>
                    </div>
                  </div>
                  <!-- <div class="column is-3" v-show="smsSendDateTime">
                    <div class="field">
                      <div class="control is-fullwidth">
                        <label class="label">
                            SMS Send Datetime
                        </label>
                        <input class="input" type="datetime-local" v-model="sms.scheduleSmsDateTime" :min="minDateSms" :max="maxDateSms"/>
                      </div>
                    </div>
                  </div> -->
                </div>
                <div class="columns form-row parent-class" v-show="Parent">
                  <div class="column">
                    <div class="field">
                      <label class="label"> Classes (Selected : {{ sms.classes.length }}) </label>
                      <div class="control select is-fullwidth">
                        <multiselect

                          @select="Selected"
                          @remove="removeClass"
                          label="name"
                          track-by="name"
                          class="overflowmultiselect1"
                          :close-on-select="false"
                          :clear-on-select="false"
                          :preserve-search="false"
                          :multiple="true"
                          :options="classesArr"
                          v-model="sms.classes"
                        >
                          <template slot="selection" slot-scope="{ values, isOpen }"
                            ><span class="multiselect__single" v-if="values.name &amp;&amp; !isOpen">{{ values.name }} </span></template
                          >
                        </multiselect>
                      </div>
                    </div>
                  </div>
                  <div class="column">
                    <div class="field">
                      <label class="label"> Class Sections (Selected : {{ sms.section.length }}) </label>
                      <div class="control select is-fullwidth">
                        <multiselect
                          class="overflowmultiselect1"
                          label="name"
                          track-by="name"
                          :close-on-select="false"
                          :clear-on-select="false"
                          :preserve-search="false"
                          :multiple="true"
                          :options="sectionArr"
                          v-model="sms.section"
                        >
                          <template slot="selection" slot-scope="{ values, isOpen }"
                            ><span class="multiselect__single" v-if="values.name &amp;&amp; !isOpen">{{ values.name }} </span></template
                          >
                        </multiselect>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="columns mt-15 form-row parent-class" v-show="Parent">
                  <div class="column">
                    <div class="field">
                      <label class="label">
                        Select Gender
                        <span class="requir">*</span>
                      </label>
                      <div class="control is-fullwidth">
                        <input type="radio" value="all" v-model="sms.gender" />
                        <label for="all" class="left-margin">All</label>
                        <input type="radio" style="margin-left: 20px" value="FEMALE" v-model="sms.gender" />
                        <label for="girl" class="left-margin">Girl</label>
                        <input type="radio" style="margin-left: 20px" value="MALE" v-model="sms.gender" />
                        <label for="boy" class="left-margin">Boy</label>
                      </div>
                    </div>
                  </div>
                  <div class="column">
                    <label class="label"> Student Type </label>
                    <div class="field">
                      <div class="control is-fullwidth">
                        <input type="radio" id="all" value="all" v-model="sms.studentType" />
                        <label for="all" class="left-margin">All</label>
                        <input type="radio" style="margin-left: 20px" id="isNewStudent" value="isNewStudent" v-model="sms.studentType" />
                        <label for="isNewStudent" class="left-margin">NewStudent</label>
                        <input type="radio" style="margin-left: 20px" id="isExistingStudent" value="isExistingStudent" v-model="sms.studentType" />
                        <label for="isExistingStudent" class="left-margin">ExistingStudent</label>
                      </div>
                    </div>
                  </div>
                </div>
                <footer class="column has-text-right">
                  <button class="button is-success" type="submit">Continue</button>
                </footer>
              </card-component>
            </div>
          </form>
        </b-tab-item>
        <b-tab-item class="label" label="User Listing" :disabled="isListing">
          <form @submit.prevent="showMsgTab">
            <div>
              <card-component>
                <div class="columns form-row">
                  <div class="column is-12">
                    <div class="field">
                      <div class="label has-text-right right-align">
                        Total Count: <b> {{ total }}</b
                        ><br />
                        Selected Count: <b> {{ sms.checkedRows.length }} </b>
                      </div>
                    </div>
                  </div>
                </div>
                <section class="section is-main-section">
                  <card-component class="has-table has-mobile-sort-spaced">
                    <b-input placeholder="Search..." type="search" v-model="searchTerm" @input="customSearch(searchTerm)"></b-input>
                    <b-table
                      checkable
                      :checked-rows.sync="sms.checkedRows"
                      :paginated="paginated"
                      :per-page="10"
                      :columns="columns"
                      :striped="true"
                      :hoverable="true"
                      :data="searchFilterArray"
                      v-model="sms.getAllData"
                    >
                      <section class="section" slot="empty">
                        <div class="content has-text-grey has-text-centered">
                          <template>
                            <p>
                              <b-icon icon="emoticon-sad" size="is-large" />
                            </p>
                            <p>Nothing's here&hellip;</p>
                          </template>
                        </div>
                      </section>
                    </b-table>
                  </card-component>
                </section>
                <footer class="column has-text-right">
                  <button class="button is-success" type="submit" :disabled="isDisabled">Next</button>
                </footer>
              </card-component>
            </div>
          </form>
        </b-tab-item>
        <b-tab-item class="label" label="Message Content" :disabled="isMessage">
          <form @submit.prevent="sendSMSToUser">
            <div class="columns form-row">
              <div class="column is-6">
                <div class="field left-align">
                  <label class="label">
                    {{ MsgText }}
                    <span class="has-text-danger">*</span>
                  </label>
                  <div class="control">
                    <textarea
                      @keypress="onKeyPressTxtMsg($event)"
                      @keydown="onKeyPressTxtMsg($event)"
                      @keyup="onKeyPressTxtMsg($event)"
                      required
                      v-model.trim="sms.messageText"
                      :readonly="readOnlyTxtBox"
                      placeholder="Message.."
                      type="text"
                      class="textarea resizetxtarea"
                      maxlength="90"
                      minlength="10"
                    >
                    </textarea>
                    <p v-show="showCharacter" class="text-right text-small" v-bind:class="{ 'text-danger': generateErr }">Characters :{{ totalRemainCount }}</p>
                  </div>
                </div>
              </div>
              <div class="column is-6" v-show="SendSMSTextDiv">
                <div class="field left-align">
                  <label class="label"> SMS Send Text </label>
                  <div class="control">{{ SendSMSText }}</div>
                </div>
              </div>
            </div>
            <footer class="column has-text-right">
              <button class="button is-success" :disabled="isDisabled" type="submit">Send SMS</button>
            </footer>
          </form>
        </b-tab-item>
      </b-tabs>
    </section>
  </div>
</template>
<script>
import constants from '@/utils/constants'
import CardComponent from '@/components/template/CardComponent'
import Multiselect from 'vue-multiselect'
// import moment from 'moment'
import _ from 'lodash'

export default {
  name: 'sendSms',
  components: {
    CardComponent,
    Multiselect
  },
  props: ['id'],
  data () {
    return {
      isListing: true,
      isMessage: true,
      activeTab: 0,
      limitmaxCount: 90,
      totalRemainCount: 90,
      generateErr: false,
      showCharacter: false,
      searchTerm: '',
      getSmsTitle: 'Send SMS',
      searchFilterArray: [],
      MsgText: 'Message:(Should starts with Dear Sir/Madam/Parent)',
      data: [],
      total: '',
      readOnlyTxtBox: false,
      SendSMSTextDiv: false,
      SendSMSText: '',
      Staff: false,
      franchiseeArr: [],
      classesData: [],
      classesArr: [],
      sectionArr: [],
      staffDeptArr: [],
      TableData: [],
      columns: [],
      required: false,
      paginated: false,
      requiredP: true,
      perPage: 10,
      academicYears: [],
      UserType: [{ name: 'PARENT' }, { name: 'STAFF' }],
      Parent: true,
      isDisabled: false,
      smsToParent: false,
      TemplateType: [],
      loadingComponent: null,
      notPointChk: true,
      pointChk: false,
      templateDeatils: [],
      selectClasses: [],
      staffArr: ['ALL', 'STAFF'],
      parentArr: ['ALL', 'PARENT'],
      userIDs: [],
      // minDateSms: moment().format('YYYY-MM-DDThh:mm'),
      // maxDateSms: moment().add(1, 'M').format('YYYY-MM-DDThh:mm'),
      sms: {
        franchiseeID: '',
        templateTypeValue: '',
        academicYearsValue: '',
        pointOfContact: ['point_of_contact'],
        userTypeValue: 'PARENT',
        scheduleSmsDateTime: '',
        classes: '',
        staffDept: '',
        section: '',
        gender: 'all',
        studentType: 'all',
        selectedStudent: '',
        messageText: '',
        checkedRows: [],
        getAllData: []
      }
    }
  },
  async created () {
    try {
      this.loadingComponent = this.$buefy.loading.open()
      this.getSmsTitle = 'Send SMS'
      this.getDetails()
      this.getSMSTemplate(this.parentArr)
      this.loadingComponent.close()
    } catch (e) {
      const errorMessage = (e && e.response && e.response.data.message) || e.message
      return this.errMsg(errorMessage)
    }
  },
  watch: {
    activeTab (tabNo) {
      if (tabNo === 1) {
        this.isMessage = true
      } else if (tabNo === 0) {
        this.isMessage = true
        this.isListing = true
      }
    }
  },
  methods: {
    sendSMSToUser: async function () {
      try {
        this.loadingComponent = this.$buefy.loading.open()
        this.isDisabled = true
        let filterData = {}
        this.userIDs = []
        this.sms.checkedRows.forEach(Obj => {
          if (Obj.userId && !this.userIDs.includes(Obj.userId)) {
            this.userIDs.push(Obj.userId)
          }
        })
        filterData.userIDs = this.userIDs
        filterData.franchiseeID = this.sms.franchiseeID
        if (this.sms.userTypeValue === 'PARENT') {
          filterData.pointOfContact = this.sms.pointOfContact
          filterData.userType = 'ENROLL'
        } else {
          filterData.userType = this.sms.userTypeValue
        }
        filterData.templateID = this.sms.templateTypeValue
        filterData.pageName = 'SEND_SMS'
        if (this.templateDeatils.templateSenderKey === 'F21Y6052') {
          const sendSMSCount = await http.post(`${constants.API_URL}/api/communication/notifications/sms/login`, filterData)
          if (sendSMSCount.data.SendCount > 0) {
            this.activeTab = 0
            this.isMessage = false
            this.isListing = false
            this.clearData()
            return this.okMsg(`${sendSMSCount.data.SendCount} SMS Send Successfully`)
          } else {
            this.activeTab = 0
            return this.okMsg(`SMS Send Successfully`)
          }
        }
      } catch (e) {
        this.isDisabled = false
        return this.errMsg(e.message)
      } finally {
        this.loadingComponent.close()
      }
    },
    getSMSTemplate: async function (templateUserTypeArr) {
      try {
        let filterTemplateData = {
          templateType: 'SMS',
          templatePageType: 'SEND_SMS',
          templateUserType: templateUserTypeArr
        }
        const dataTemplate = await http.post(`${constants.API_URL}/api/communication/template/details`, filterTemplateData)
        if (dataTemplate.data && dataTemplate.data.count > 0) {
          this.required = true
        } else {
          this.required = false
        }
        this.sms.templateTypeValue = ''
        this.TemplateType = dataTemplate.data.rows
      } catch (e) {
        return this.errMsg(e.message)
      }
    },
    getSMSTemplateContent: async function (templateId) {
      try {
        const dataTemplate = await http.get(`${constants.API_URL}/api/communication/template/${templateId}`)
        this.templateDeatils = dataTemplate.data
        if (this.templateDeatils.templateContent && this.templateDeatils.templateName !== 'Announcements' && this.templateDeatils.templateName !== 'Greetings') {
          this.sms.messageText = window.atob(this.templateDeatils.templateContent)
          this.readOnlyTxtBox = true
        } else {
          this.MsgText = 'Message'
          this.readOnlyTxtBox = false
          this.showCharacter = false
        }
      } catch (e) {
        return this.errMsg(e.message)
      }
    },
    getDetails: async function () {
      const { data } = await http.get(`${constants.API_URL}/api/franchisee/active`)
      this.franchiseeArr = data.rows
      const classesData = await http.get(`${constants.API_URL}/api/students/class`)
      this.classesArr = classesData.data.rows
      const dataAcademicYears = await http.get(`${constants.API_URL}/api/franchiseeAcademicYears?isCurrentAcademicYear=true`)
      this.academicYears = dataAcademicYears.data.rows
    },
    onChangeSMSTemplate: function (event) {
      let templateId = event.target.value
      this.getSMSTemplateContent(templateId)
    },
    onKeyPressTxtMsg: function (event) {
      this.showCharacter = true
      this.totalRemainCount = this.limitmaxCount
      this.generateErr = this.totalRemainCount < 0
      if (this.templateDeatils.templateName === 'Announcements') {
        this.totalRemainCount = this.limitmaxCount - event.target.value.length
        this.generateErr = this.totalRemainCount < 0
        this.SendSMSTextDiv = true
        this.SendSMSText = window.atob(this.templateDeatils.templateContent)
        this.SendSMSText = this.SendSMSText.replace('SMS_CONTENT', event.target.value)
      } else if (this.templateDeatils.templateName === 'Greetings') {
        this.MsgText = ''
        this.totalRemainCount = this.limitmaxCount - event.target.value.length
        this.generateErr = this.totalRemainCount < 0
        this.SendSMSText = window.atob(this.templateDeatils.templateContent)
        this.SendSMSTextDiv = true
        this.SendSMSText = this.SendSMSText.replace('SMS_CONTENT', event.target.value)
      }
    },
    checkBoxPoint: function (event) {
      if (event.target.checked === true && event.target.value === 'point_of_contact') {
        this.notPointChk = true
        this.pointChk = false
        this.sms.pointOfContact = ['point_of_contact']
      } else if (event.target.checked === false && event.target.value === 'point_of_contact') {
        this.pointChk = true
        this.notPointChk = false
        this.sms.pointOfContact = ['Father']
      } else if (!this.sms.pointOfContact.includes('Guardian') && !this.sms.pointOfContact.includes('Father') && !this.sms.pointOfContact.includes('Mother')) {
        this.notPointChk = true
        this.pointChk = false
        this.sms.pointOfContact = ['point_of_contact']
      }
    },
    onChangeUserType: function (event) {
      this.checkedNames = ''
      if (event.target.value === 'PARENT') {
        this.Parent = true
        this.Staff = false
        this.requiredP = true
        this.requiredS = false
        this.MsgText = 'Message:(Should starts with Dear Parent)'
        this.getSMSTemplate(this.parentArr)
      } else if (event.target.value === 'STAFF') {
        this.Parent = false
        this.Staff = true
        this.requiredS = true
        this.requiredP = false
        this.staffDeptArr = [{ name: 'Teaching' }, { name: 'Non Teaching' }]
        this.MsgText = 'Message:(Should starts with Dear Sir/Madam)'
        this.getSMSTemplate(this.staffArr)
      }
    },
    Selected: function (value, id) {
      let classname = value.name
      let updatearr = {}
      value.studentSections.forEach(Obj => {
        updatearr = {
          id: Obj.id,
          name: classname + '-' + Obj.name
        }
        this.sectionArr.push(updatearr)
      })
    },
    removeClass: function (value, id) {
      let idArr = []
      value.studentSections.forEach(Obj => {
        idArr.push(Obj.id)
      })
      this.sectionArr = this.sectionArr.filter(item => !idArr.includes(item.id))
      this.sms.section = ''
    },
    GetUserListing: function () {
      this.TableData = []
      if (this.sms.userTypeValue.toString() === 'PARENT') {
        this.data.forEach(Obj => {
          let dataObj = {}
          dataObj['StudentName'] = Obj.studentEnrollment.studentName
          dataObj['userId'] = Obj.id
          dataObj['FatherName'] = Obj.studentEnrollment.fatherName
          if (this.sms.pointOfContact.includes('point_of_contact')) {
            dataObj['pointOfContact'] = Obj.studentEnrollment.fatherMobile
          }
          if (this.sms.pointOfContact.includes('Father')) {
            dataObj['Father'] = Obj.studentEnrollment.fatherMobile
          }
          if (this.sms.pointOfContact.includes('Mother')) {
            dataObj['Mother'] = Obj.studentEnrollment.motherMobile
          }
          if (this.sms.pointOfContact.includes('Guardian')) {
            dataObj['Guardian'] = Obj.studentEnrollment.guardianMobile
          }
          dataObj['Class'] = Obj.studentClass.name
          dataObj['Section'] = Obj.studentSection.name
          this.TableData.push(dataObj)
        })
        this.columns = [{ field: 'userId', label: 'Student Id', visible: false }]
        this.columns = [{ field: 'FatherName', label: 'Parent Name', visible: false }]
        this.columns = [{ field: 'StudentName', label: 'Student Name' }]
        if (this.sms.pointOfContact.includes('point_of_contact')) {
          this.columns.push({ field: 'pointOfContact', label: 'Point Of Contact' })
        }
        if (this.sms.pointOfContact.includes('Father')) {
          this.columns.push({ field: 'Father', label: 'Parent' })
        }
        if (this.sms.pointOfContact.includes('Mother')) {
          this.columns.push({ field: 'Mother', label: 'Mother' })
        }
        if (this.sms.pointOfContact.includes('Guardian')) {
          this.columns.push({ field: 'Guardian', label: 'Guardian' })
        }
        this.columns.push({ field: 'Section', label: 'Section' }, { field: 'Class', label: 'Class' })
        this.searchFilterArray = this.TableData
      } else if (this.sms.userTypeValue.toString() === 'STAFF') {
        this.columns = [
          { field: 'StaffName', label: 'Staff Name' },
          { field: 'userId', label: 'Staff ID', visible: false },
          { field: 'StaffMobileNo', label: 'Mobile No' },
          { field: 'StaffType', label: 'Staff Type' }
        ]
        this.data.forEach(Obj => {
          let dataObj = {}
          if (Obj.user.firstName && Obj.user.userStaff.id) {
            dataObj['StaffName'] = Obj.user.firstName + ' ' + Obj.user.lastName
            dataObj['userId'] = Obj.user.userStaff.userID
            dataObj['StaffMobileNo'] = Obj.user.userStaff.mobileNo
            dataObj['StaffType'] = Obj.user.userStaff.isTeachingStaff ? 'Teaching' : 'Non Teaching'
          }
          this.TableData.push(dataObj)
        })
        this.searchFilterArray = this.TableData
      }
    },
    customSearch: function (value) {
      if (_.isEmpty(value)) {
        this.searchFilterArray = this.TableData
      } else {
        if (this.sms.userTypeValue.toString() === 'PARENT') {
          this.searchFilterArray = _.filter(
            this.TableData,
            item =>
              (this.sms.pointOfContact.includes('point_of_contact') && item.StudentName && item.StudentName.toLowerCase().search(value.toLowerCase()) >= 0) ||
              (item.Class && item.Class.toLowerCase().search(value.toLowerCase()) >= 0) ||
              (item.Section && item.Section.toLowerCase().search(value.toLowerCase()) >= 0) ||
              (this.sms.pointOfContact.includes('point_of_contact') && item.pointOfContact && item.pointOfContact.toLowerCase().search(value.toLowerCase()) >= 0) ||
              (this.sms.pointOfContact.includes('Father') && item.Father && item.Father.toLowerCase().search(value.toLowerCase()) >= 0) ||
              (this.sms.pointOfContact.includes('Mother') && item.Mother && item.Mother.toLowerCase().search(value.toLowerCase()) >= 0) ||
              (this.sms.pointOfContact.includes('Guardian') && item.Guardian && item.Guardian.toLowerCase().search(value.toLowerCase()) >= 0)
          )
        } else if (this.sms.userTypeValue.toString() === 'STAFF') {
          this.searchFilterArray = _.filter(
            this.TableData,
            item => (item && item.StaffName.toLowerCase().search(value.toLowerCase()) >= 0) || (item && item.StaffMobileNo.toLowerCase().search(value.toLowerCase()) >= 0) ||
            (item && item.StaffType.toLowerCase().search(value.toLowerCase()) >= 0)
          )
        }
      }
      this.total = this.searchFilterArray.length
    },
    showListing: async function () {
      try {
        this.sms.checkedRows.length = 0
        this.sms.checkedRows = []
        this.isMessage = true
        this.loadingComponent = this.$buefy.loading.open()
        if (this.TemplateType.length === 0) {
          return this.errMsg('Please add Template for Send_SMS Page')
        } else if (this.TemplateType.length > 0) {
          if (this.sms.userTypeValue.toString() === 'PARENT') {
            if (this.sms.classes.length === 0) {
              return this.errMsg('Please Select Atleast One Class')
            } else if (this.sms.section.length === 0) {
              return this.errMsg('Please Select Atleast One Section of Class')
            } else if (this.sms.classes.length > 0 && this.sms.section.length > 0) {
              this.activeTab = 1
              this.isListing = false
              let classesIds = []
              this.sms.classes.forEach(Obj => {
                classesIds.push(Obj.id)
              })
              let sectionIds = []
              this.sms.section.forEach(Obj => {
                sectionIds.push(Obj.id)
              })
              let filterData = {}
              filterData.franchiseeID = this.sms.franchiseeID
              filterData.classID = classesIds
              filterData.sectionID = sectionIds
              filterData.academicYearID = this.sms.academicYearsValue
              filterData.isActive = true
              if (this.sms.gender !== 'all') {
                filterData.gender = this.sms.gender
              }
              if (this.sms.studentType === 'isExistingStudent') {
                filterData.isNewStudent = false
                filterData.isExistingStudent = true
              } else if (this.sms.studentType === 'isNewStudent') {
                filterData.isNewStudent = true
                filterData.isExistingStudent = false
              } else {
                filterData.isNewStudent = false
                filterData.isExistingStudent = false
              }
              try {
                const response = await http.post(`${constants.API_URL}/api/student/`, filterData)
                this.data = response.data
                this.total = this.data.length
                this.paginated = !!this.total
              } catch (e) {
                const errorMessage = (e && e.response && e.response.data.message) || e.message
                return this.errMsg(`Error While Listing of Student: ${errorMessage}`)
              }
            }
          } else if (this.sms.userTypeValue.toString() === 'STAFF') {
            if (this.sms.staffDept.length === 0) {
              return this.errMsg('Please Select Atleast One Department')
            } else if (this.sms.staffDept.length > 0) {
              this.activeTab = 1
              this.isListing = false
              let appendUrl = ''
              if (this.sms.staffDept.length === 1 && this.sms.staffDept[0].name === 'Teaching') {
                appendUrl = '&isTeachingStaff=1'
              } else if (this.sms.staffDept.length === 1 && this.sms.staffDept[0].name === 'Non Teaching') {
                appendUrl = '&isTeachingStaff=0'
              }
              const response = await http.get(`${constants.API_URL}/api/staff/approved?franchiseeID=${this.sms.franchiseeID}${appendUrl}`)
              this.data = response.data
              this.total = this.data.length
              this.paginated = !!this.total
            }
          }
        }
        if (this.total === 0) {
          this.isDisabled = true
        } else {
          this.isDisabled = false
        }
        this.GetUserListing()
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        return this.errMsg(errorMessage)
      } finally {
        this.loadingComponent.close()
      }
    },
    showMsgTab: function () {
      if (this.sms.checkedRows.length === 0) {
        return this.errMsg('Please Select Atleast One User')
      } else {
        this.activeTab = 2
        this.isMessage = false
      }
    },
    okMsg (msg) {
      return this.$buefy.dialog.alert({
        type: 'is-success',
        message: msg,
        hasIcon: true,
        animation: 'zoom-out',
        size: 'is-medium',
        icon: ' mdi-exclamation',
        iconPack: 'mdi',
        ariaRole: 'alertdialog',
        ariaModal: true
      })
    },
    errMsg (msg) {
      return this.$buefy.dialog.alert({
        message: msg,
        type: 'is-danger',
        hasIcon: true,
        animation: 'zoom-out',
        size: 'is-medium',
        icon: ' mdi-exclamation',
        iconPack: 'mdi',
        ariaRole: 'alertdialog',
        ariaModal: true
      })
    },
    clearData () {
      this.sms.franchiseeID = ''
      this.sms.templateTypeValue = ''
      this.sms.academicYearsValue = ''
      this.sms.pointOfContact = ['point_of_contact']
      this.sms.scheduleSmsDateTime = ''
      this.sms.classes = ''
      this.sms.staffDept = ''
      this.sms.section = ''
      this.sms.gender = 'all'
      this.sms.studentType = 'all'
      this.sms.selectedStudent = ''
      this.sms.messageText = ''
      this.sms.checkedRows = []
      this.sms.getAllData = []
    }
  }
}
</script>
<style>
.left-margin {
  margin-left: 5px;
}
.b-table .table-wrapper {
  overflow-y: hidden;
}
.left-align {
  margin-left: 20px;
}
.right-align {
  margin-right: 24px;
}
.chk {
  margin-left: 10px;
  margin-right: 10px;
}
textarea.resizetxtarea {
  resize: none;
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
